import { render } from "./RadioInput.vue?vue&type=template&id=66f2bf43"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"
script.render = render

export default script